/**
 * 全局指令注册入口
 * 统一管理所有自定义指令
 */

import trackingDirectives from './tracking'

/**
 * 注册所有自定义指令
 * @param {App} app - Vue应用实例
 */
export function setupDirectives(app) {
  // 注册埋点指令
  app.use(trackingDirectives)
  
  // 可以在这里注册其他自定义指令
  // app.use(otherDirectives)
}

export default {
  install(app) {
    setupDirectives(app)
  }
}
